import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COMPANY, BRANDS, NAV } from "@/config/site";

const socials = Object.entries(COMPANY.social).filter(([, url]) => url);

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[var(--ink)] text-[#e9e6e0] grain overflow-hidden" data-testid="site-footer">
      <div className="container-x relative pt-20 pb-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="inline-block rounded bg-[var(--paper)] p-4">
              <img src={COMPANY.logo} alt={`${COMPANY.name} logo`} width="160" height="126" loading="lazy" className="h-24 w-auto" />
            </div>
            <p className="mt-6 max-w-sm text-[0.95rem] leading-relaxed text-[#c9c5bd]">{COMPANY.intro}</p>
            <Link to="/partner-with-us" className="mt-8 inline-flex items-center gap-2 border-b border-[var(--sky)] pb-1 text-white" data-testid="footer-partner-link">
              Start a partnership conversation <ArrowUpRight size={16} />
            </Link>
          </div>
          <div className="lg:col-span-3">
            <h2 className="font-mono-label text-xs uppercase tracking-[0.2em] text-[#b5b0a7]">Brand Portfolio</h2>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3 lg:grid-cols-1">
              {BRANDS.map((b) => (
                <li key={b.id}>
                  <Link to={`/brands#${b.id}`} className="link-underline text-[0.95rem]" data-testid={`footer-brand-${b.id}`}>{b.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <h2 className="font-mono-label text-xs uppercase tracking-[0.2em] text-[#b5b0a7]">Company</h2>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}><Link to={n.to} className="link-underline text-[0.95rem]" data-testid={`footer-nav-${n.to.replace("/", "") || "home"}`}>{n.label}</Link></li>
              ))}
              <li><Link to="/partner-with-us" className="link-underline text-[0.95rem]" data-testid="footer-nav-partner">Partner With Us</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h2 className="font-mono-label text-xs uppercase tracking-[0.2em] text-[#b5b0a7]">Contact</h2>
            <ul className="mt-5 space-y-3 text-[0.95rem] text-[#c9c5bd]">
              <li data-testid="footer-contact-email">{COMPANY.contact.email ? <a href={`mailto:${COMPANY.contact.email}`} className="link-underline text-white">{COMPANY.contact.email}</a> : "Official email — to be updated"}</li>
              <li data-testid="footer-contact-phone">{COMPANY.contact.phone ? <a href={`tel:${COMPANY.contact.phone}`} className="link-underline text-white">{COMPANY.contact.phone}</a> : "Official phone — to be updated"}</li>
              <li data-testid="footer-contact-address">{COMPANY.contact.address || "Registered office — to be updated"}</li>
            </ul>
            {socials.length > 0 && (
              <ul className="mt-6 flex gap-4">
                {socials.map(([k, url]) => (
                  <li key={k}><a href={url} target="_blank" rel="noopener noreferrer" className="link-underline capitalize" data-testid={`footer-social-${k}`}>{k}</a></li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <div aria-hidden="true" className="font-display mt-20 select-none text-[18vw] leading-[0.8] tracking-tight text-white/[0.06] lg:text-[13rem]">Suvirika</div>
        <div className="mt-6 flex flex-col gap-4 border-t border-white/15 pt-6 text-sm text-[#b5b0a7] md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-copyright">© {year} {COMPANY.name}. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="link-underline" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms-of-use" className="link-underline" data-testid="footer-terms-link">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
